import { optimizePeaksWithLogs } from "./optimizePeaksWithLogs.js";
/**
 * Optimize the position (x), max intensity (y), full width at half maximum (fwhm)
 * and the ratio of gaussian contribution (mu) if it's required. It currently supports three kind of shapes: gaussian, lorentzian and pseudovoigt
 * @param data - An object containing the x and y data to be fitted.
 * @param peakList - A list of initial parameters to be optimized. e.g. coming from a peak picking [{x, y, width}].
 */
export function optimizePeaks(data, peakList, options = {}) {
    return optimizePeaksWithLogs(data, peakList, options).optimizedPeaks;
}
//# sourceMappingURL=optimizePeaks.js.map